export default __webpack_public_path__ + "static/media/screen_facebook_1_1.60847db6.png";